module.exports = __webpack_public_path__ + "img/材料力学6_4_2.04cd03b4.jpg";